import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=01a009ec&scoped=true&"
import script from "./MenuBar.vue?vue&type=script&lang=js&"
export * from "./MenuBar.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=01a009ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a009ec",
  null
  
)

export default component.exports